import {
  handleCallActivated,
  handleIncomingCall,
  terminateCall,
  updateParticipantState,
  updateParticipantStatus,
  updateParticipantsPermits,
} from 'redux/actions/callActions';
import { getUpdatedChatInfo, readMessages, receiveWebsocketMessage } from 'redux/actions/chatsActions';
import store from 'store';
import { messageStatusEnum } from 'types/chatsType';
import {
  FullMessageType,
  handleCallProps,
  handleMessageProps,
  handleMessageUtilProps,
  wsMessageTypeEnum,
} from './useWebsocketTypes';

const { dispatch } = store;

function handleSystemMessage({ message, callId, userId }: handleMessageUtilProps): void {
  const { dialog: dialogId } = message;
  if (!userId) return;
  if (message?.action?.type === 'changeChat') {
    const deletedUserIds = message.action?.changedUsers?.del || [];
    if (deletedUserIds) if (callId === dialogId && deletedUserIds.includes(userId)) dispatch(terminateCall());
  }
}

function handleAnswerlessCall({ message, callId, userId }: handleMessageUtilProps): void {
  try {
    if (message.dialog === callId) {
      const unansweredUsers = JSON.parse(message.text).users as string[];
      if (unansweredUsers.find((idUser) => idUser === userId)) {
        dispatch(terminateCall());
      }
    }
  } catch (e) {
    console.error('handleAnswerlessCall error: ', e);
  }
}

type handleChangePartisipantStatusProps = {
  dialog: FullMessageType['dialog'];
  statusUpdates: FullMessageType['statusUpdates'];
};

function handleChangeParticipantStatus(props: handleChangePartisipantStatusProps) {
  props.statusUpdates?.forEach((update) => dispatch(updateParticipantStatus(update)));
}

type handleChangePartisipantPermitsProps = {
  dialog: FullMessageType['dialog'];
  permitsUpdate: FullMessageType['permitsUpdate'];
};

function handleChangeParticipantPermits(props: handleChangePartisipantPermitsProps) {
  if (props.permitsUpdate) dispatch(updateParticipantsPermits(props.permitsUpdate));
}

function handleChangeParticipantStates(states: FullMessageType['states']) {
  if (states) states?.forEach((newState) => dispatch(updateParticipantState(newState)));
}

function handleCall({ fullMessage, userId, callId, chatsData }: handleCallProps): void {
  const { cType, dialog, owner } = fullMessage;
  if (cType === wsMessageTypeEnum.callUsers) dispatch(handleCallActivated({}));
  if (cType === wsMessageTypeEnum.callActivated) dispatch(handleCallActivated({}));
  if (cType === wsMessageTypeEnum.participantStateChanged) handleChangeParticipantStates(fullMessage?.states);
  if (cType === wsMessageTypeEnum.participantStatusChanged)
    handleChangeParticipantStatus({ dialog, statusUpdates: fullMessage.statusUpdates });
  if (cType === wsMessageTypeEnum.participantPermitsChanged)
    handleChangeParticipantPermits({ dialog, permitsUpdate: fullMessage?.permitsUpdate });
  if (cType === wsMessageTypeEnum.notAnswer)
    handleAnswerlessCall({ callId: callId as number, message: fullMessage, userId: userId as string });
  if (cType === wsMessageTypeEnum.systemMessage)
    handleSystemMessage({ callId: callId as number, message: fullMessage, userId: userId as string });
  if (cType === wsMessageTypeEnum.callEnded && fullMessage.dialog != null)
    dispatch(getUpdatedChatInfo({ id: fullMessage.dialog, messageInfo: fullMessage.action }));
  // TODO: Когда вернемся к звонкам, стоит вынести handleIncomingCall из саги в отдельный асинхронный модуль
  if (chatsData) dispatch(handleIncomingCall({ cType, callerId: owner, chats: [...chatsData], dialogId: dialog }));
}

export function handleMessage({ fullMessage, selectedChatId, userId, callId, chatsData }: handleMessageProps): void {
  try {
    const dialogId = Number(fullMessage.dialog);
    const normalizedMessage = { ...fullMessage, dialog: dialogId };
    const isUnread = fullMessage.owner !== userId;

    if (dialogId === selectedChatId && isUnread && fullMessage.id) {
      dispatch(readMessages({ id: dialogId, messages: [fullMessage.id], status: messageStatusEnum.read }));
    }
    dispatch(
      getUpdatedChatInfo({
        fullMessage: normalizedMessage,
        id: dialogId,
        messageInfo: fullMessage.action,
      })
    );
    dispatch(receiveWebsocketMessage({ fullMessage: normalizedMessage, isUnread }));
    handleCall({ callId, chatsData, fullMessage: normalizedMessage, userId });
  } catch (e) {
    console.error('websocket handleMessage error: ', e);
  }
}
